export const initialExploreQuery: ExploreQueryT = {
    metrics: [],
    dimensions: [],
    filters: [],
};
